import { Grid } from '@mui/material';
import React from 'react';
import { CerebroStyledBox, CerebroText } from '../../../shared/components';
import {
	CurrentUser,
	DataRoomUser,
	DataRoom,
	UnlockUser,
	AssociatedTeamMember,
	MilestoneReport,
} from '../../../shared/models';
import { DataRoomUserItem } from './DataRoomUserItem';

interface DataRoomUserListProps {
	dataRoomGuid: string | undefined;
	currentUser: CurrentUser;
	dataRoom: DataRoom;
	users: DataRoomUser[];
	tab: string;
	unlockUser: (user: UnlockUser) => void;
	accessLogs: (user: UnlockUser) => void;
	optOutUser: (user: DataRoomUser) => void;
	addNote: (user: DataRoomUser) => void;
	viewNotes: (user: DataRoomUser) => void;
	addTeamMember: (user: DataRoomUser) => void;
	removeTeamMember: (member: AssociatedTeamMember) => void;
	sendInvite: (user: UnlockUser) => void;
	sendEmail: (user: DataRoomUser) => void;
	viewEmails: (user: DataRoomUser) => void;
	uploadNda: (user: DataRoomUser) => void;
	grantAccess: (user: DataRoomUser) => void;
	deleteDataRoomUser: (user: DataRoomUser) => void;
	viewOptOut: (user: DataRoomUser) => void;
	contactDetails: (user: DataRoomUser) => void;
	teamMemberDetails: (user: AssociatedTeamMember) => void;
	progressDetails: (milestone: MilestoneReport | null) => void;
}

export const DataRoomUserList: React.FC<DataRoomUserListProps> = ({
	dataRoomGuid,
	currentUser,
	dataRoom,
	users,
	tab,
	unlockUser,
	accessLogs,
	optOutUser,
	addNote,
	viewNotes,
	addTeamMember,
	removeTeamMember,
	sendInvite,
	sendEmail,
	viewEmails,
	uploadNda,
	grantAccess,
	deleteDataRoomUser,
	viewOptOut,
	contactDetails,
	teamMemberDetails,
	progressDetails,
}) => {
	return (
		<>
			{(users == null || users.length == 0 || dataRoomGuid == null) && (
				<CerebroStyledBox>
					<CerebroText sx={{ marginBottom: 2 }}>There are no participants matching this filter.</CerebroText>
				</CerebroStyledBox>
			)}

			{users != null && users.length > 0 && dataRoomGuid && (
				<Grid container spacing={2} alignItems="stretch">
					{users.map(user => {
						return (
							<DataRoomUserItem
								key={tab + '-' + user.guid}
								dataRoomGuid={dataRoomGuid}
								currentUser={currentUser}
								dataRoom={dataRoom}
								user={user}
								tab="inactive"
								unlockUser={unlockUser}
								accessLogs={accessLogs}
								optOutUser={optOutUser}
								addNote={addNote}
								viewNotes={viewNotes}
								addTeamMember={addTeamMember}
								removeTeamMember={removeTeamMember}
								sendInvite={sendInvite}
								sendEmail={sendEmail}
								viewEmails={viewEmails}
								uploadNda={uploadNda}
								grantAccess={grantAccess}
								deleteDataRoomUser={deleteDataRoomUser}
								viewOptOut={viewOptOut}
								contactDetails={contactDetails}
								teamMemberDetails={teamMemberDetails}
								progressDetails={progressDetails}
							/>
						);
					})}
				</Grid>
			)}
		</>
	);
};
